import { applyOrganizationBrandingSession } from './organization-branding-session';

applyOrganizationBrandingSession();
